import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { AppLocation } from '../../models/interface/geo';

@Injectable()
export class WaterBodyDAO extends BaseDAO<WaterBody> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.WATER_BODY);
  }

  public getActiveMarkets(): Observable<WaterBody[]> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/active-markets';
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<WaterBody[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public getWaterBodiesForVessel(ids: number[]): Observable<WaterBody[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/water-bodies-by-ids';
    let method = 'put';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    let data = {
      ids: ids,
    };
    return this.apiHelper.apiCall<WaterBody[]>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  public createWaterBody(wb: any): Observable<WaterBody> {
    const url: string = this.apiHelper.getServiceName() + this.getResource();
    let method = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<WaterBody>(url, method, null, wb, headers);
  }

  public getComingSoonBodies(): Observable<WaterBody[]> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/coming-soon';
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<WaterBody[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public loadActiveMarkets(): Observable<WaterBody[]> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/active-markets';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<WaterBody[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public getFeaturedBodies(): Observable<WaterBody[]> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/featured';
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<WaterBody[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public getByWaterBodyId(waterBodyId: number): Observable<WaterBody> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/' + waterBodyId;
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<WaterBody>(url, method, null, null, headers);
  }

  public updateFromPartial(
    id: number,
    waterBody: Partial<WaterBody>,
  ): Observable<Charter> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/partial/' + id;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, waterBody, headers);
  }

  public buildWaterBodyString(WaterBodyId: number): Observable<WaterBody> {
    const url =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      WaterBodyId +
      '/';
    const method = 'GET';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<WaterBody>(url, method, null, null, headers);
  }

  public updateMultipleFeaturedMarkets(
    waterBodies: Partial<WaterBody>[],
  ): Observable<WaterBody> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/update-multiple-featured-markets';
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, waterBodies, headers);
  }

  public findByVanityUrl(vanityUrl: string): Observable<WaterBody> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/vanityUrl/' +
      vanityUrl;
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<WaterBody>(url, method, null, null, headers);
  }

  public findClosestWaterBodyToPlacesInput(
    location: AppLocation,
  ): Observable<WaterBody> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/google-places/search/';
    let method = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<WaterBody>(
      url,
      method,
      null,
      location,
      headers,
    );
  }

  public findClosestWaterBodyToLatLong(latLongObj: any): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/water-body-search/';
    let method = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<any>(url, method, null, latLongObj, headers);
  }

  findDuplicateWaterbodyByLatLong(
    lat: number,
    long: number,
  ): Observable<WaterBody[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/admin/find-duplicates';
    let method = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    let data = {
      lat: lat,
      long: long,
    };

    return this.apiHelper.apiCall<WaterBody[]>(
      url,
      method,
      null,
      data,
      headers,
    );
  }
}
